import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	notificationColumnHeader: {
		defaultMessage: 'Notification',
		id: 'personal-settings-notifications-config-table.common.notification-column-header',
		description:
			'The header on the notifications config table for the column that says what the notification is you are configuring',
	},
	notificationColumnHeaderAllIssues: {
		defaultMessage: 'Notifications for all issues',
		id: 'personal-settings-notifications-config-table.common.notification-column-header-all-issues',
		description:
			'The header on the notifications config table for the column that says what the notification is you are configuring pertainng to all issues',
	},
	notificationColumnHeaderRelevantIssues: {
		defaultMessage: 'Notifications for relevant issues',
		id: 'personal-settings-notifications-config-table.common.notification-column-header-relevant-issues',
		description:
			'The header on the notifications config table for the column that says what the notification is you are configuring pertainng to relevant issues',
	},
	relevantIssueNotificationTableInfoIconText: {
		defaultMessage:
			'An issue is considered relevant to you if you’re watching it, or if you’re the issue’s reporter or assignee.',
		id: 'personal-settings-notifications-config-table.common.relevant-issue-notification-table-info-icon-text',
		description:
			'Text shown in a tooltip when hovering over the info icon in the relevant issue notification table',
	},
	emailColumnHeader: {
		defaultMessage: 'Email',
		id: 'personal-settings-notifications-config-table.common.email-column-header',
		description:
			'The header on the notifications config table for the email column that contains the checkboxes for the email notifications',
	},
	inProductColumnHeader: {
		defaultMessage: 'In product',
		id: 'personal-settings-notifications-config-table.common.in-product-column-header',
		description:
			'The header on the notifications config table for the in product column that contains the checkboxes for the in product notifications',
	},
	issueAssignedType: {
		defaultMessage: 'You’re assigned to an issue',
		id: 'personal-settings-notifications-config-table.common.issue-assigned-type',
		description: 'The label for the notification type when a user is assigned to an issue',
	},
	mentionedNotificationType: {
		defaultMessage: 'You’re mentioned on an issue',
		id: 'personal-settings-notifications-config-table.common.mentioned-notification-type',
		description: 'The label for the notification type when a user is mentioned on an issue',
	},
	issueDeletedType: {
		defaultMessage: 'An issue is deleted',
		id: 'personal-settings-notifications-config-table.common.issue-deleted-type',
		description: 'The label for the notification type when an issue is deleted',
	},
	issueUpdatedType: {
		defaultMessage: 'An issue is edited',
		id: 'personal-settings-notifications-config-table.common.issue-updated-type',
		description: 'The label for the notification type when an issue is edited',
	},
	commentCreatedType: {
		defaultMessage: 'A comment is added',
		id: 'personal-settings-notifications-config-table.common.comment-created-type',
		description: 'The label for the notification type when a comment is made',
	},
	commentEditedType: {
		defaultMessage: 'A comment is edited',
		id: 'personal-settings-notifications-config-table.common.comment-edited-type',
		description: 'The label for the notification type when a comment is edited',
	},
	commentDeletedType: {
		defaultMessage: 'A comment is deleted',
		id: 'personal-settings-notifications-config-table.common.comment-deleted-type',
		description: 'The label for the notification type when a comment is deleted',
	},
	issueCreatedType: {
		defaultMessage: 'An issue is created',
		id: 'personal-settings-notifications-config-table.common.issue-created-type',
		description: 'The label for the notification type when an issue is created',
	},
	issueMovedType: {
		defaultMessage: 'An issue is moved',
		id: 'personal-settings-notifications-config-table.common.issue-moved-type',
		description: 'The label for the notification type when an issue is moved',
	},
	mentionsCombinedType: {
		defaultMessage: 'You’re mentioned on an issue',
		id: 'personal-settings-notifications-config-table.common.mentions-combined-type',
		description: 'The label for the notification type when a user is mentioned in a comment',
	},
	worklogCombinedType: {
		defaultMessage: 'A work log is created, edited, or deleted',
		id: 'personal-settings-notifications-config-table.common.worklog-combined-type',
		description: 'The label for the notification type when a work log is created',
	},
	miscellaneousIssueEventCombined: {
		defaultMessage: "Other issue events (including a change to an issue's status)",
		id: 'personal-settings-notifications-config-table.common.miscellaneous-issue-event-combined',
		description:
			'The label for the notification type when an miscelleanous issue event occurs, eg: status change, generic, custom',
	},
	defaultNotificationSettings: {
		defaultMessage: 'Default notification settings',
		id: 'personal-settings-notifications-config-table.common.default-notification-settings',
		description:
			'The heading for the "global" notifications settings applied across all of a users projects',
	},
	defaultNotificationSettingsDescription: {
		defaultMessage:
			'Default notification settings apply across your projects. These can be overridden by your email preferences, or by custom project notifications settings.',
		id: 'personal-settings-notifications-config-table.common.default-notification-settings-description',
		description:
			'The description for the "global" notifications settings applied across all of a users projects',
	},
	issueChangesCategoryType: {
		defaultMessage: 'Changes to issues',
		id: 'personal-settings-notifications-config-table.common.issue-changes-category-type',
		description:
			'The description for the notifications settings group/ category of type issue changes, applied across all of a users projects',
	},
	commentChangesCategoryType: {
		defaultMessage: 'Changes to comments on issues',
		id: 'personal-settings-notifications-config-table.common.comment-changes-category-type',
		description:
			'The description for the notifications settings group/category of type comment changes, applied across all of a users projects',
	},
	notificationColumnHeaderAllIssuesIssueTermRefresh: {
		defaultMessage: 'Notifications for all work items',
		id: 'personal-settings-notifications-config-table.common.notification-column-header-all-issues-issue-term-refresh',
		description:
			'The header on the notifications config table for the column that says what the notification is you are configuring pertainng to all issues',
	},
	notificationColumnHeaderRelevantIssuesIssueTermRefresh: {
		defaultMessage: 'Notifications for relevant work items',
		id: 'personal-settings-notifications-config-table.common.notification-column-header-relevant-issues-issue-term-refresh',
		description:
			'The header on the notifications config table for the column that says what the notification is you are configuring pertainng to relevant issues',
	},
	relevantIssueNotificationTableInfoIconTextIssueTermRefresh: {
		defaultMessage:
			'A work item is considered relevant to you if you’re watching it, or if you’re the reporter or assignee.',
		id: 'personal-settings-notifications-config-table.common.relevant-issue-notification-table-info-icon-text-issue-term-refresh',
		description:
			'Text shown in a tooltip when hovering over the info icon in the relevant issue notification table',
	},
	issueAssignedTypeIssueTermRefresh: {
		defaultMessage: 'You’re assigned to a work item',
		id: 'personal-settings-notifications-config-table.common.issue-assigned-type-issue-term-refresh',
		description: 'The label for the notification type when a user is assigned to an issue',
	},
	mentionedNotificationTypeIssueTermRefresh: {
		defaultMessage: 'You’re mentioned on a work item',
		id: 'personal-settings-notifications-config-table.common.mentioned-notification-type-issue-term-refresh',
		description: 'The label for the notification type when a user is mentioned on an issue',
	},
	issueDeletedTypeIssueTermRefresh: {
		defaultMessage: 'A work item is deleted',
		id: 'personal-settings-notifications-config-table.common.issue-deleted-type-issue-term-refresh',
		description: 'The label for the notification type when an issue is deleted',
	},
	issueUpdatedTypeIssueTermRefresh: {
		defaultMessage: 'A work item is edited',
		id: 'personal-settings-notifications-config-table.common.issue-updated-type-issue-term-refresh',
		description: 'The label for the notification type when an issue is edited',
	},
	issueCreatedTypeIssueTermRefresh: {
		defaultMessage: 'A work item is created',
		id: 'personal-settings-notifications-config-table.common.issue-created-type-issue-term-refresh',
		description: 'The label for the notification type when an issue is created',
	},
	issueMovedTypeIssueTermRefresh: {
		defaultMessage: 'A work item is moved',
		id: 'personal-settings-notifications-config-table.common.issue-moved-type-issue-term-refresh',
		description: 'The label for the notification type when an issue is moved',
	},
	mentionsCombinedTypeIssueTermRefresh: {
		defaultMessage: 'You’re mentioned on a work item',
		id: 'personal-settings-notifications-config-table.common.mentions-combined-type-issue-term-refresh',
		description: 'The label for the notification type when a user is mentioned in a comment',
	},
	miscellaneousIssueEventCombinedIssueTermRefresh: {
		defaultMessage: "Other work item events (including a change to a work item's status)",
		id: 'personal-settings-notifications-config-table.common.miscellaneous-issue-event-combined-issue-term-refresh',
		description:
			'The label for the notification type when an miscelleanous issue event occurs, eg: status change, generic, custom',
	},
	issueChangesCategoryTypeIssueTermRefresh: {
		defaultMessage: 'Changes to work items',
		id: 'personal-settings-notifications-config-table.common.issue-changes-category-type-issue-term-refresh',
		description:
			'The description for the notifications settings group/ category of type issue changes, applied across all of a users projects',
	},
	commentChangesCategoryTypeIssueTermRefresh: {
		defaultMessage: 'Changes to comments on work items',
		id: 'personal-settings-notifications-config-table.common.comment-changes-category-type-issue-term-refresh',
		description:
			'The description for the notifications settings group/category of type comment changes, applied across all of a users projects',
	},
});
